import { array, nonEmptyArray } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { NonEmptyArray } from 'fp-ts/NonEmptyArray';
import { sampleSize } from '@mews-commander/utils';

export interface ItemWithWeight {
    weight: number;
}

export const getRandomItemByWeight = <T extends ItemWithWeight>(items: NonEmptyArray<T>) =>
    pipe(
        items,
        nonEmptyArray.reduce(items, (result, item) =>
            nonEmptyArray.concat(
                result,
                array.makeBy(item.weight, () => item)
            )
        ),
        (itemsMakedByWeight) => sampleSize(1, itemsMakedByWeight) as NonEmptyArray<T>,
        nonEmptyArray.head
    );
